/**
 * Globale helpers: dialog-drawers (menu, winkelwagen) en roterende announcements.
 * Bewust klein gehouden; sectie-specifieke logica hoort in eigen modules.
 */

// Marker voor CSS die alleen mag gelden mét JS (zoals verborgen reveal-begintoestand)
document.documentElement.classList.add('js');

// Drawers: elke [data-dialog-open="<id>"] opent de <dialog id="<id>"> als modal.
// Links met dit attribuut vallen zonder JS terug op hun href.
document.addEventListener('click', (event) => {
  // Signatuur: fietsbel — element "tingelt" kort bij klik
  const ringer = event.target.closest('[data-ring]');
  if (ringer) {
    ringer.classList.remove('is-ringing');
    void ringer.offsetWidth; // herstart de animatie bij snelle herhaalde kliks
    ringer.classList.add('is-ringing');
  }

  const opener = event.target.closest('[data-dialog-open]');
  if (opener) {
    // Ctrl/Cmd/Shift-klik op een link-opener (zoals het winkelmand-icoon):
    // niet kapen, de browser opent de href gewoon in een nieuw tabblad
    const gewijzigd = event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0;
    if (gewijzigd && opener.closest('a[href]')) return;
    const dialog = document.getElementById(opener.dataset.dialogOpen);
    if (dialog) {
      event.preventDefault();
      dialog.showModal();
    }
    return;
  }

  const closer = event.target.closest('[data-dialog-close]');
  if (closer) {
    closer.closest('dialog')?.close();
    return;
  }

  // Klik op de backdrop (buiten het dialog-paneel) sluit de drawer
  const dialog = event.target.closest('dialog[open]');
  if (dialog && event.target === dialog) {
    const rect = dialog.getBoundingClientRect();
    const inside =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;
    if (!inside) dialog.close();
  }
});

// Announcement-bar: roteer items als er meer dan één is
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function initAnnouncementBar(bar) {
  const items = bar.querySelectorAll('[data-announcement]');
  if (items.length < 2 || reducedMotion || bar.dataset.bound) return;
  bar.dataset.bound = 'true';

  let index = 0;
  const volgende = () => {
    items[index].removeAttribute('data-active');
    index = (index + 1) % items.length;
    items[index].setAttribute('data-active', '');
  };
  let timer = setInterval(volgende, 4000);

  // WCAG 2.2.2: automatisch wisselende content moet te pauzeren zijn
  bar.querySelector('[data-announcement-pauze]')?.addEventListener('click', (event) => {
    const knop = event.currentTarget;
    const gepauzeerd = knop.getAttribute('aria-pressed') === 'true';
    if (gepauzeerd) timer = setInterval(volgende, 4000);
    else clearInterval(timer);
    knop.setAttribute('aria-pressed', String(!gepauzeerd));
  });
}

for (const bar of document.querySelectorAll('[data-announcement-bar]')) initAnnouncementBar(bar);

// Theme editor: een herrenderde sectie krijgt onze per-sectie-JS niet opnieuw
// (modules draaien één keer per paginalading). Minimale herstelset zodat de
// preview bruikbaar blijft: reveal-elementen meteen tonen en de announcement-
// rotatie herstarten; fietsvinder en faq-filter herbinden zichzelf via een
// eigen shopify:section:load-listener. Live rendert een pagina maar één keer,
// dus daar speelt dit nooit.
if (window.Shopify?.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    for (const el of event.target.querySelectorAll('[data-reveal]')) el.classList.add('is-revealed');
    for (const bar of event.target.querySelectorAll('[data-announcement-bar]')) initAnnouncementBar(bar);
  });
}
